import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../../service/service.js';
import {BillingService} from '../../../service/billing/billingService.js';
import {ElementUtil} from '../../../utils/elementUtil.js';
import {TimeUtil} from '../../../utils/timeUtil.js';
import {StringUtil} from '../../../utils/stringUtil.js';
import {BaseComponent} from '../../basecomponent.js';


/* global customElements */
class CommentGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();		
		
		var commentGrid = this;
		setTimeout(function(){
			commentGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var commentGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},				
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					permissions: ['ADMIN_BILLING_ACCOUNTS:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}
				},							
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',					
					permissions: ['ADMIN_BILLING_ACCOUNTS:DELETE'],
					'class': 'spacer-toolbar-item',
					style: 'float: right;',					
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}			
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column'							
			},			
			children: [	
				{
					tag: 'vaadin-grid-column',
					'flex-grow': '0',
					width: '50px',					
					renderer: function(root, column, rowData) {
						var expander = ElementUtil.create({
							tag: 'span',
							trustedInnerHTML: true,
							innerHTML: '<b>+</b>',
							properties: {
								expanded: false
							},
							listeners: {
								click: function() {
									if (expander.expanded) {
										expander.innerHTML = '<b>+</b>';
										expander.expanded = false;
										grid.closeItemDetails(root.item);
									} else {
										expander.innerHTML = '<b>-</b>';
										expander.expanded = true;
										grid.openItemDetails(root.item);
									}
								}
							}
						});
						//this must be set for expand to open
						root.item = rowData.item;
						if (!root.firstElementChild) {
							root.append(expander);
						}
					}
				},
				{						
					path: 'commentDts',
					header: 'Comment Date',					
					width: '9em',
					resizable: true,	
					renderer: function(root, column, rowData) {
						if (rowData.item.commentDts) {
							var date = TimeUtil.parseDate(rowData.item.commentDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				},
				{						
					path: 'accountCommentType',
					header: 'Type',
					width: '9em',
					resizable: true,
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.commentTypeDescription;
					}
				},
				{						
					path: 'acctComment',
					header: 'Comment',	
					resizable: true,
					'flex-grow': '1'
				},								
				{						
					path: 'updateUser',
					header: 'Update User',					
					resizable: true,
					width: '9em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',						
					width: '9em',
					direction: 'desc',
					resizable: true,
					renderer: function(root, column, rowData) {
						if (rowData.item.updateDts) {
							var date = TimeUtil.parseDate(rowData.item.updateDts);						
							root.innerHTML = TimeUtil.formatDateStandard(date);						
						}
					}
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});		
	
		grid.rowDetailsRenderer = function(root, grid, rowData) {
			if (!root.firstElementChild) {
				root.innerHTML = '<div style="border: 1px solid"><div style="padding: 5px;">' + 
						StringUtil.newLineToHTML(rowData.item.acctComment) + 
						'</div></div>';
			}
		};		
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		commentGrid.append(flexLayout);		
		
		var actionRefresh = function() {
			
			var loadMask = commentGrid.showLoading();
			BillingService.getAccountService().getAccountComments(commentGrid.detail.companyId)
			.then(function(records){							
				loadMask.remove();
				grid.activeItem = null;						
				grid.items = records;
			});
		};
		actionRefresh();
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit Comment' : 'Add Comment',
				icon: 'lumo:edit',
				width: 600,
				height: 400,
				listeners: {
					ready: function() {						
						addEditWin.show();
								
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [																				
										{
											tag: 'vaadin-combo-box',											
											label: 'Type', 
											name: 'accountCommentType',
											required: true,
											'item-value-path': 'code',
											'item-label-path': 'description',
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('AccountCommentType').then(function(data){
													combo.items = data;
												});
											}
										},
										{
											tag: 'vaadin-text-area',
											label: 'Comment',
											name: 'acctComment',
											style: 'max-height: 150px; min-height: 150px;',
											required: true,
											maxlength: 4048
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Comment Date',
											name: 'commentDts',	
											value: TimeUtil.formatDateForDateTimeLoad(new Date()),
											required: true
										},																			
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																
															formPanel.submitForm({
																preSubmit: function(data) {	
																	if (record) {
																		data.acctCommentId = record.acctCommentId;
																	}
																	return data;
																},
																actualCall: function(data) {																	
																	return BillingService.getAccountService().saveComment(commentGrid.detail.companyId, data, record ? true : false);
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved Comment', {
																		theme: 'success',
																		position: 'top-stretch'
																	});																	
																	actionRefresh();
																	addEditWin.close();
																}
															});
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
						
						if (record) {							
							formPanel.load(record);								
						}						
					
					}
				}
			});
		
						
		};
		
		var actionDelete = function(record) {
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to remove selected comment?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting...');													
							
							BillingService.getAccountService().deleteComment(record.companyId, record.acctCommentId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted comment', {									
									theme: 'success'
								});
								actionRefresh();
							});															
							
						}	
					},
					{
						text: 'No'
					}
				]
			});				
		};		

	}
	
};
customElements.define('dl-account-comment-grid', CommentGrid);

